import React, { useState } from 'react';
import styled from 'styled-components';
import { Title } from './Title';
import { SectionWrapper } from './SectionWrapper';
import { useAnalytics } from '../context/AnalyticsContext';

const Tabs = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

const TabButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 10px 20px;
  font-size: 1.6rem;
  margin: 0 10px;
  color: ${({ active }) => (active ? '#444' : '#999')};
  border-bottom: ${({ active }) => (active ? '2px solid #333' : 'none')};
  transition: all 0.3s ease;

  &:hover,
  &:focus {
    color: #333;
    outline: none;
  }
`;

const ContentWrapper = styled.div`
  height: 100%;
  padding: 1.6rem 0;
  /* display: flex; */
  /* justify-content: center; */
  /* align-items: center; */
`;

const Content = styled.div`
  /* text-align: ${props => props.center ? 'center' : 'left'}; */
  display: ${({ active }) => (active ? 'block' : 'none')};
  margin: 1rem 0;
`;

const DetailsContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 3rem;
  align-items: center;
  @media(max-width: 768px) {
    gap: 0;
  }
`
const Link = styled.a``;
const Box = styled.div`
  /* flex: 1; */
`
const Image = styled.img`
  max-width: 90px;
  width: 100%;
  height: auto;
  @media(max-width: 768px) {
      display: none;
  }
`
const CompanyLogo = styled.img`
  /* max-width: 300px; */
  width: 100%;
  height: auto;
  @media(max-width: 768px) {
      display: none;
  }
`

const Heading = styled.h3`
  color: #eee;
  line-height: 2rem;
`;
const SubHeading = styled.h4`
  color: #ccc;
  line-height: 1.7em;
`;
const Text = styled.p`
  color: #ccc;
  font-size: 1.6rem;
  text-align: justify;
  line-height: 1.6;
  p{
    margin-bottom: 0.25em;
  }
`;
const List = styled.ul`
  color: #acacac;
  font-size: 1.6rem;
  padding: 1rem 2rem;
`;

const ListItems = styled.li`
  list-style: disc;
`;

const SmallText = styled.p`
  color: #aaa;
  font-size: 1.4rem;
  b{
    color: #ccc;
  }
`;

const Blockquote = styled.blockquote`
  border-left: 2px solid #ccc;
  padding-left: 1em;
  margin: 1em 0;
  color: var(--color-grey-500);
`

const Eduexp = () => {
  const [activeTab, setActiveTab] = useState("education");
  const { trackTabClick } = useAnalytics();

  const handleTabChange = (tab) => {
    trackTabClick(tab);
    setActiveTab(tab);
  };
  return (
    <SectionWrapper>
      <Title>Education & Experience</Title>
      <Text>
        <p>
          Below is my educational background, consisting of a Bachelor of Engineering, C-DAC and Work experience.
        </p>
        <p>
          While working with Infinite computer solutions, I gain valuable insights into Nokia SMP Project.
          These experiences have not only prepared me for the challenges of Software development, but have also instilled
          in me a deep sense of adaptability, resilience, and a passion for continuous growth. I am eager to leverage
          my diverse background and multifaceted skill set to contribute meaningfully to organizations I will work in the future.
        </p>
        <Blockquote>In every pause lies the potential for growth.</Blockquote>
        <p>
          During my gaps, the time when I was not working, I embraced opportunities for learning, skill development, and personal growth, 
          transforming challenges into strengths and emerging more capable and resilient.
        </p>
      </Text>
      <ContentWrapper>
        <Content active={activeTab === 'education'}>
          <DetailsContainer>
            <Link href='https://www.cdac.in' rel="noreferrer noopener" target="_blank">
              <Image src='/C-DAC.png' alt='C-DAC logo'></Image>
            </Link>
            <Box>
              <Heading>PG-DAC in Full Stack Development, Hyderabad</Heading>
              <SubHeading>Centre for Development of Advanced Computing, September 2022</SubHeading>
              <SmallText><b>Project: </b>Food delivery system (Java, Springboot, JPA, mySQL, JSP, etc.)</SmallText>
            </Box>
          </DetailsContainer>
        </Content>
        <Content active={activeTab === 'education'}>
          <DetailsContainer>
            <Link href='http://www.unipune.ac.in' rel="noreferrer noopener" target="_blank">
              <Image src='/sppu.png' alt='SPPU logo'></Image>
            </Link>
            <Box>
              <Heading>Computer Science Engineering, PUNE</Heading>
              <SubHeading>University of Pune, July 2021</SubHeading>
              <SmallText><b>Project: </b>Website phishing detection system</SmallText>
            </Box>
          </DetailsContainer>
        </Content>
        <Content active={activeTab === 'experience'}>
          <DetailsContainer>
            <Link href='https://www.infinite.com' rel="noreferrer noopener" target="_blank">
              <CompanyLogo src='/infinok.jpg' />
            </Link>
            <Box>
              <Heading>Associate Software Engineer, Vizag, Andhra Pradesh</Heading>
              <SubHeading>Infinite Computer Solutions, November 2022 - July 2023</SubHeading>
              <List>
                <ListItems>Contributed to the SMP (Service Management Platform) project, an R&D project at Nokia.</ListItems>
                <ListItems>Successfully migrated CCFK Library (React JS) as part of the migration work.</ListItems>
                <ListItems>Assumed responsibility for challenging files that other team members found difficult to complete.</ListItems>
                <ListItems>Completed all assigned tasks within deadlines, showcasing strong time management skills.</ListItems>
                <ListItems>Provided support and assistance to fellow team members facing difficulties, fostering a collaborative work experience.</ListItems>
              </List>
            </Box>
          </DetailsContainer>
        </Content>
      </ContentWrapper>
      <Tabs>
        <TabButton
          onClick={() => handleTabChange('education')}
          active={activeTab === 'education'}
        >
          Education
        </TabButton>
        <TabButton
          onClick={() => handleTabChange('experience')}
          active={activeTab === 'experience'}
        >
          Experience
        </TabButton>
      </Tabs>
    </SectionWrapper>
  );
};

export default Eduexp;
